import { apiClient } from '@utils';

export const useCustomers = () => {
  const result = apiClient.customer.listCustomers.useQuery(['customersList'], {});
  return { ...result, data: result.data?.body?.data || [] };
};
